export class SubjectSelected {
    codigo: number;
    nombre: String;
    consecutivo: number;
    cualitativa: boolean;
    banco: String;
    periodo: String;
    nota: String;
    creditos: number;
    comentario: String;
    tipo: String;
}
